<template>
  <div id="index">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <template>
          <el-row :gutter="24">
            <el-col :xs="24" :sm="12" :lg="8">
              <el-button type="primary" :plain="!dialogFirst" icon="el-icon-circle-plus-outline"
                @click="dialogMenu('First')" v-if="judge('Menu_Create')" style="margin-bottom: 10px">{{ $t('CreateFirstLevelMenu') }}
              </el-button>
              <el-button type="primary" :plain="!dialogSecond" icon="el-icon-circle-plus-outline"
                v-if="judge('Menu_Create')" @click="dialogMenu('Second')" style="margin-bottom: 10px">{{ $t('CreateSecondLevelMenu') }}
              </el-button>

              <el-button type="primary" :plain="!dialogThree" icon="el-icon-circle-plus-outline"
                v-if="judge('Menu_Create')" @click="dialogMenu('Three')" style="margin-bottom: 10px">{{ $t('CreateThreeLevelMenu') }}
              </el-button>
              <div class="custom-tree-container">
                <div class="block">
                  <el-tree :data="MenuData" node-key="id" @node-click="handleNodeClick" :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ $t(node.label) }}</span>

                      <span class="fr">
                        <el-button type="primary" @click="editMenu(data)" v-if="judge('Menu_Update')"
                          icon="el-icon-edit" circle></el-button>
                        <el-button type="danger" @click="deleteId(data.id)" v-if="judge('Menu_Delete')"
                          icon="el-icon-delete" circle></el-button>
                      </span>
                      <span class="clear"></span>
                    </span>
                  </el-tree>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :lg="16">
              <div v-if="dialogFirst">
                <h3 class="menutitle">
                  <i class="el-icon-circle-plus-outline"></i>{{ $t('CreateFirstLevelMenu') }}
                </h3>
                <el-form ref="menuform" v-if="dialogFirst" :model="menuform" label-width="120px" class="menutable">
                  <el-form-item :label="$t('Code')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DisplayName')" prop="name" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ChineseName')" prop="chineseName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.chineseName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnglishName')" prop="englishName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.englishName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('URL')" prop="url" :rules="[{ required: true, message: $t('LinkCannotBeEmpty') }]">
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item label="PBIUrl" prop="PBIUrl">
                    <el-input v-model="menuform.PBIUrl"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Icon')" prop="icon">
                    <i v-if="menuform.icon" :class="menuform.icon"></i>
                    <el-input style="width: 94%; margin-left: 2%" @focus="dialogTableVisible = true"
                      v-model="menuform.icon"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Describe')" prop="description" :rules="[{ required: true, message: $t('DescriptionCannotBeEmpty')}]">
                    <el-input v-model="menuform.description" type="textarea" :rows="2"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Sort')" prop="sortNum" :rules="[{ required: true, message: $t('SortingCannotBeEmpty') }]">
                    <el-input type="number" :min="1" v-model="menuform.sortNum" style="max-width: 100px"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnabledYN')" prop="isEnable" :rules="[{ required: true, message: $t('PleaseSelect') }]">
                    <el-select v-model="menuform.isEnable" :placeholder="$t('el.select.placeholder')" style="max-width: 100px">
                      <el-option value="0" :label="$t('yes')">{{ $t('yes') }}</el-option>
                      <el-option value="1" :label="$t('No')">{{ $t('No') }}</el-option>
                    </el-select>
                  </el-form-item>
                  <!--                            <el-form-item label="是否删除">-->
                  <!--                                <el-select v-model="menuform.det" :placeholder="$t('el.select.placeholder')" style="max-width: 100px;">-->
                  <!--                                    <el-option value="0" label="是">是</el-option>-->
                  <!--                                    <el-option value="1" label="否">否</el-option>-->
                  <!--                                </el-select>-->
                  <!--                            </el-form-item>-->

                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogFirst = false">{{ $t('Cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="dialogSecond">
                <h3 class="menutitle">
                  <i class="el-icon-circle-plus-outline"></i>{{ $t('CreateSecondLevelMenu') }}
                </h3>
                <el-form ref="menuform" v-if="dialogSecond" :model="menuform" label-width="120px" class="menutable">
                  <el-form-item :label="$t('Code')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DisplayName')" prop="name" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ChineseName')" prop="chineseName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.chineseName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnglishName')" prop="englishName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.englishName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ParentMenu')" prop="parentId" :rules="[{ required: true, message: $t('PleaseSelectTheParentMenu') }]">
                    <el-select v-model="menuform.parentId" :placeholder="$t('el.select.placeholder')">
                      <el-option v-for="(item, index) in MenuData" :key="'inx2' + index" :label="item.label"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('URL')" prop="url" :rules="[{ required: true, message: $t('LinkCannotBeEmpty') }]">
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item label="PBIUrl" prop="PBIUrl">
                    <el-input v-model="menuform.PBIUrl"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Icon')" prop="icon">
                    <i v-if="menuform.icon" :class="menuform.icon"></i>
                    <el-input style="width: 94%; margin-left: 2%" @focus="dialogTableVisible = true"
                      v-model="menuform.icon"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Describe')" prop="description" :rules="[{ required: true, message: $t('DescriptionCannotBeEmpty')}]">
                    <el-input v-model="menuform.description" type="textarea" :rows="2"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Sort')" prop="sortNum" :rules="[{ required: true, message: $t('SortingCannotBeEmpty') }]">
                    <el-input type="number" :min="1" v-model="menuform.sortNum" style="max-width: 100px"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnabledYN')" prop="isEnable" :rules="[{ required: true, message: $t('PleaseSelect') }]">
                    <el-select v-model="menuform.isEnable" :placeholder="$t('el.select.placeholder')" style="max-width: 100px">
                      <el-option value="0" :label="$t('yes')">{{ $t('yes') }}</el-option>
                      <el-option value="1" :label="$t('No')">{{ $t('No') }}</el-option>
                    </el-select>
                  </el-form-item>
                  <!--                            <el-form-item label="是否删除">-->
                  <!--                                <el-select v-model="menuform.det" :placeholder="$t('el.select.placeholder')" style="max-width: 100px;">-->
                  <!--                                    <el-option value="0" label="是">是</el-option>-->
                  <!--                                    <el-option value="1" label="否">否</el-option>-->
                  <!--                                </el-select>-->
                  <!--                            </el-form-item>-->
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogSecond = false">{{ $t('Cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <div v-if="dialogThree">
                <h3 class="menutitle">
                  <i class="el-icon-circle-plus-outline"></i>{{ $t('CreateThreeLevelMenu') }}
                </h3>
                <el-form ref="menuform" v-if="dialogThree" :model="menuform" label-width="120px" class="menutable">
                  <el-form-item :label="$t('Code')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DisplayName')" prop="name" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ChineseName')" prop="chineseName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.chineseName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnglishName')" prop="englishName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.englishName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ParentMenu')" :rules="[{ required: true, message: $t('PleaseSelectTheParentMenu') }]">
                    <el-input v-model="selectTreeText"></el-input>
                    <!-- <el-cascader :options="MenuData" v-model="menuform.parentId"  :props="{ multiple: true, checkStrictly: true }" clearable>
                                        <template slot-scope="{ node, data }">
                                            <span>{{ data.label }}</span>
                                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                        </template>
                                        </el-cascader> -->
                    <el-tree :data="MenuData" ref="edittree" node-key="id" @node-click="handleNodeClick1"
                      :expand-on-click-node="false" :props="defaultProps">
                      <span slot-scope="{ node }">
                        <span>{{ node.label }}</span>
                        <span class="fr"> </span>
                        <span class="clear"></span>
                      </span>
                    </el-tree>
                  </el-form-item>
                  <el-form-item :label="$t('URL')" prop="url" :rules="[{ required: true, message: $t('LinkCannotBeEmpty') }]">
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item label="PBIUrl" prop="PBIUrl">
                    <el-input v-model="menuform.PBIUrl"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Icon')" prop="icon">
                    <i v-if="menuform.icon" :class="menuform.icon"></i>
                    <el-input style="width: 94%; margin-left: 2%" @focus="dialogTableVisible = true"
                      v-model="menuform.icon"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Describe')" prop="description" :rules="[{ required: true, message: $t('DescriptionCannotBeEmpty')}]">
                    <el-input v-model="menuform.description" type="textarea" :rows="2"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Sort')" prop="sortNum" :rules="[{ required: true, message: $t('SortingCannotBeEmpty') }]">
                    <el-input type="number" :min="1" v-model="menuform.sortNum" style="max-width: 100px"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnabledYN')" prop="isEnable" :rules="[{ required: true, message: $t('PleaseSelect') }]">
                    <el-select v-model="menuform.isEnable" :placeholder="$t('el.select.placeholder')" style="max-width: 100px">
                      <el-option value="0" :label="$t('yes')">{{ $t('yes') }}</el-option>
                      <el-option value="1" :label="$t('No')">{{ $t('No') }}</el-option>
                    </el-select>
                  </el-form-item>
                  <!--                            <el-form-item label="是否删除">-->
                  <!--                                <el-select v-model="menuform.det" :placeholder="$t('el.select.placeholder')" style="max-width: 100px;">-->
                  <!--                                    <el-option value="0" label="是">是</el-option>-->
                  <!--                                    <el-option value="1" label="否">否</el-option>-->
                  <!--                                </el-select>-->
                  <!--                            </el-form-item>-->
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogThree = false">{{ $t('Cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <div v-if="dialogFirstEdit">
                <h3 class="menutitle">
                  <i class="el-icon-circle-plus-outline"></i>{{$t('EditFirstLevelMenu')}}
                </h3>
                <el-form ref="menuform" v-if="dialogFirstEdit" :model="menuform" label-width="120px" class="menutable">
                  <el-form-item :label="$t('Code')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DisplayName')" prop="name" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ChineseName')" prop="chineseName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.chineseName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnglishName')" prop="englishName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.englishName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('URL')" prop="url" :rules="[{ required: true, message: $t('LinkCannotBeEmpty') }]">
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item label="PBIUrl" prop="PBIUrl">
                    <el-input v-model="menuform.PBIUrl"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Icon')" prop="icon">
                    <i v-if="menuform.icon" :class="menuform.icon"></i>
                    <el-input style="width: 94%; margin-left: 2%" @focus="dialogTableVisible = true"
                      v-model="menuform.icon"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Describe')" prop="description" :rules="[{ required: true, message: $t('DescriptionCannotBeEmpty') }]">
                    <el-input v-model="menuform.description" type="textarea" :rows="2"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Sort')" prop="sortNum" :rules="[{ required: true, message: $t('SortingCannotBeEmpty') }]">
                    <el-input type="number" :min="1" v-model="menuform.sortNum" style="max-width: 100px"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnabledYN')" prop="isEnable" :rules="[{ required: true, message: $t('PleaseSelect') }]">
                    <el-select v-model="menuform.isEnable" :placeholder="$t('el.select.placeholder')" style="max-width: 100px">
                      <el-option value="0" :label="$t('yes')">{{ $t('yes') }}</el-option>
                      <el-option value="1" :label="$t('No')">{{ $t('No') }}</el-option>
                    </el-select>
                  </el-form-item>
                  <!--                            <el-form-item label="是否删除">-->
                  <!--                                <el-select v-model="menuform.det" :placeholder="$t('el.select.placeholder')" style="max-width: 100px;">-->
                  <!--                                    <el-option value="0" label="是">是</el-option>-->
                  <!--                                    <el-option value="1" label="否">否</el-option>-->
                  <!--                                </el-select>-->
                  <!--                            </el-form-item>-->

                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogFirstEdit = false">{{ $t('Cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <div v-if="dialogSecondEdit">
                <h3 class="menutitle">
                  <i class="el-icon-circle-plus-outline"></i>{{ $t('EditSecondaryMenu') }}
                </h3>
                <el-form v-if="dialogSecondEdit" ref="menuform" :model="menuform" label-width="120px" class="menutable">
                  <el-form-item :label="$t('Code')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DisplayName')" prop="name" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ChineseName')" prop="chineseName" >
                    <el-input v-model="menuform.chineseName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnglishName')" prop="englishName" >
                    <el-input v-model="menuform.englishName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ParentMenu')" prop="parentId" :rules="[{ required: true, message: $t('PleaseSelectTheParentMenu') }]">
                    <el-select v-model="menuform.parentId" :placeholder="$t('el.select.placeholder')">
                      <el-option v-for="(item, index) in MenuData" :key="'inx1' + index" :label="item.label"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('URL')" prop="url" :rules="[{ required: true, message: $t('LinkCannotBeEmpty') }]">
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item label="PBIUrl" prop="PBIUrl">
                    <el-input v-model="menuform.PBIUrl"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Icon')" prop="icon">
                    <i v-if="menuform.icon" :class="menuform.icon"></i>
                    <el-input style="width: 94%; margin-left: 2%" @focus="dialogTableVisible = true"
                      v-model="menuform.icon"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Describe')" prop="description" :rules="[{ required: true, message: $t('DescriptionCannotBeEmpty') }]">
                    <el-input v-model="menuform.description" type="textarea" :rows="2"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Sort')" prop="sortNum" :rules="[{ required: true, message: $t('SortingCannotBeEmpty') }]">
                    <el-input type="number" :min="1" v-model="menuform.sortNum" style="max-width: 100px"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnabledYN')" prop="isEnable" :rules="[{ required: true, message: $t('PleaseSelect') }]">
                    <el-select v-model="menuform.isEnable" :placeholder="$t('el.select.placeholder')" style="max-width: 100px">
                      <el-option value="0" :label="$t('yes')">{{ $t('yes') }}</el-option>
                      <el-option value="1" :label="$t('No')">{{ $t('No') }}</el-option>
                    </el-select>
                  </el-form-item>
                  <!--                            <el-form-item label="是否删除">-->
                  <!--                                <el-select v-model="menuform.det" :placeholder="$t('el.select.placeholder')" style="max-width: 100px;">-->
                  <!--                                    <el-option value="0" label="是">是</el-option>-->
                  <!--                                    <el-option value="1" label="否">否</el-option>-->
                  <!--                                </el-select>-->
                  <!--                            </el-form-item>-->
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogSecondEdit = false">{{ $t('Cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <div v-if="dialogThreeEdit">
                <h3 class="menutitle">
                  <i class="el-icon-circle-plus-outline"></i>{{ $t('EditThirdLevelMenu') }}
                </h3>
                <el-form v-if="dialogThreeEdit" ref="menuform" :model="menuform" label-width="120px" class="menutable">
                  <el-form-item :label="$t('Code')" prop="code">
                    <el-input v-model="menuform.code"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DisplayName')" prop="name" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.name"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ChineseName')" prop="chineseName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.chineseName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnglishName')" prop="englishName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="menuform.englishName"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ParentMenu')" :rules="[{ required: true, message: $t('PleaseSelectTheParentMenu') }]">
                    <el-input v-model="selectTreeText"></el-input>
                    <!-- <el-cascader :options="MenuData" v-model="menuform.parentId"  :props="{ multiple: true, checkStrictly: true }" clearable>
                                        <template slot-scope="{ node, data }">
                                            <span>{{ data.label }}</span>
                                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                        </template>
                                        </el-cascader> -->
                    <el-tree :data="withOutLevel(MenuData, 3)" ref="edittree" node-key="id" default-expand-all
                      @node-click="handleNodeClick1" :expand-on-click-node="false" :props="defaultProps">
                      <span slot-scope="{ node }">
                        <span>{{ node.label }}</span>
                        <span class="fr"> </span>
                        <span class="clear"></span>
                      </span>
                    </el-tree>
                  </el-form-item>
                  <el-form-item :label="$t('URL')" prop="url" :rules="[{ required: true, message: $t('LinkCannotBeEmpty') }]">
                    <el-input v-model="menuform.url"></el-input>
                  </el-form-item>
                  <el-form-item label="PBIUrl" prop="PBIUrl">
                    <el-input v-model="menuform.PBIUrl"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Icon')" prop="icon">
                    <i v-if="menuform.icon" :class="menuform.icon"></i>
                    <el-input style="width: 94%; margin-left: 2%" @focus="dialogTableVisible = true"
                      v-model="menuform.icon"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Describe')" prop="description" :rules="[{ required: true, message: $t('DescriptionCannotBeEmpty') }]">
                    <el-input v-model="menuform.description" type="textarea" :rows="2"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('Sort')" prop="sortNum" :rules="[{ required: true, message: $t('SortingCannotBeEmpty') }]">
                    <el-input type="number" :min="1" v-model="menuform.sortNum" style="max-width: 100px"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EnabledYN')" prop="isEnable" :rules="[{ required: true, message: $t('PleaseSelect') }]">
                    <el-select v-model="menuform.isEnable" :placeholder="$t('el.select.placeholder')" style="max-width: 100px">
                      <el-option value="0" :label="$t('yes')">{{ $t('yes') }}</el-option>
                      <el-option value="1" :label="$t('No')">{{ $t('No') }}</el-option>
                    </el-select>
                  </el-form-item>
                  <!--                            <el-form-item label="是否删除">-->
                  <!--                                <el-select v-model="menuform.det" :placeholder="$t('el.select.placeholder')" style="max-width: 100px;">-->
                  <!--                                    <el-option value="0" label="是">是</el-option>-->
                  <!--                                    <el-option value="1" label="否">否</el-option>-->
                  <!--                                </el-select>-->
                  <!--                            </el-form-item>-->
                  <el-form-item>
                    <el-button type="success" @click="onSubmit('menuform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogThreeEdit = false">{{ $t('Cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
        </template>
      </el-main>
    </el-scrollbar>

    <el-dialog :title="$t('SelectIcon')" :visible.sync="dialogTableVisible">
      <el-row :gutter="24" class="icons">
        <div class="iconList" v-for="(item, index) in icons" @click="getIcon(item)" :key="index">
          <i :class="item"></i>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {
  CreateMenu,
  GetAllMenus,
  GetAllMenus1,
  DeleteMenu,
  UpdateMenu,
  getAllpermissionMenu,
} from "../../api/api";
import { icons } from "../../assets/fonts/font-awesome";
import { mapState } from "vuex";
import { judgePermission } from "../../utils/util";
import { delItemFormLocalstorage } from "../../../utils/package-localstorage";

export default {
  name: "index",
  async mounted() {
    await this.getDataList();

    // console.log(icons)
    this.icons = icons;
  },
  data() {
    return {
      dialogFirst: false,
      dialogSecond: false,
      dialogThree: false,
      dialogTableVisible: false,
      dialogFirstEdit: false,
      dialogSecondEdit: false,
      dialogThreeEdit: false,
      menuLevel: 0,
      icons: [],
      activeParentId: "",
      menuform: {
        name: "",
        code: "",
        isEnable: "0",
        parentId: "",
        url: "",
        PBIUrl: "",
        icon: "",
        description: "",
        englishName: "",
        chineseName: "",
        sortNum: "",
      },
      MenuData: [],
      selectTreeText: "",
      selectTreeId: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },

  methods: {
    judge(e) {
      return judgePermission(e);
    },
    handleNodeClick(data) {
      if (data.parentId == "00000000-0000-0000-0000-000000000000") {
        this.activeParentId = data.id;
        this.menuform.parentId = data.id;
      } else {
        if (this.menuLevel === 1) {
          this.activeParentId = "";
          this.menuform.parentId = data.parentId;
        }
        if (this.menuLevel === 2) {
          this.activeParentId = "";
          this.menuform.parentId = data.parentId;
          //获取父级菜单Label
          var parentMenu = this.getMenuByID(data.parentId);

          this.selectTreeText = parentMenu.label;
        }
      }
    },

    handleNodeClick1(data) {
      if (data.parentId == "00000000-0000-0000-0000-000000000000") {
        this.activeParentId = data.id;
        this.menuform.parentId = data.id;
      } else {
        if (this.menuLevel === 1) {
          this.activeParentId = "";
          this.menuform.parentId = data.parentId;
        }
        if (this.menuLevel === 2) {
          this.activeParentId = "";
          this.selectTreeId = data.id;
          this.selectTreeText = data.label;
        }
      }
    },

    openNotice() {
      this.$notify({
        title: this.$t('warn'),
        message: this.$t('warningMessage'),
        type: "warning",
      });
    },
    getIcon(e) {
      this.menuform.icon = e;
      this.dialogTableVisible = false;
    },
    deleteId(id) {
      let that = this;
      let data = { Id: id };
      this.$confirm(this.$t('DeleteMenu') + "?", this.$t('prompt'), {
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('Cancel'),
        type: "warning",
      })
        .then(() => {
          DeleteMenu(data).then((res) => {
            if (res.success) {
              that.$message.success(this.$t('DeleteSuccessful') + "!");
            }
            that.getDataList();
          });
        })
        .catch(() => { });
    },
    dialogMenu(m) {
      this.menuform = {
        name: "",
        isEnable: "0",
        parentId: this.activeParentId == "" ? "" : this.activeParentId,
        url: "",
        icon: "",
        description: " ",
        englishName: "",
        chineseName: "",
        sortNum: 1,
      };

      delete this.menuform.id;
      // if(this.dialogFirst || this.dialogSecond || this.dialogFirstEdit || this.dialogSecondEdit){
      // this.dialogFirst = false;this.dialogSecond = false;
      // this.dialogFirstEdit = false; this.dialogSecondEdit = false;
      // }
      // else{
      if (m === "First") {
        this.menuLevel = 0;
        this.dialogFirst = !this.dialogFirst;
        this.dialogSecond = false;
        this.dialogThree = false;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = false;
        this.dialogThreeEdit = false;
      }
      if (m === "Second") {
        this.menuLevel = 1;
        this.dialogFirst = false;
        this.dialogSecond = !this.dialogSecond;
        this.dialogThree = false;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = false;
        this.dialogThreeEdit = false;
      }
      if (m === "Three") {
        this.menuLevel = 2;
        this.dialogFirst = false;
        this.dialogSecond = false;
        this.dialogThree = !this.dialogThree;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = false;
        this.dialogThreeEdit = false;
      }
      // }
    },
    editMenu(e) {
       
      e.isEnable = e.isEnable ? "0" : "1";
     
      if (e.parentId === "00000000-0000-0000-0000-000000000000") {
        this.menuLevel = 0;
        this.dialogFirst = false;
        this.dialogSecond = false;
        this.dialogThree = false;
        this.dialogFirstEdit = true;
        this.dialogSecondEdit = false;
        this.dialogThreeEdit = false;
      } else if (e.menuLevel === 2) {
        this.menuLevel = 1;
        this.dialogFirst = false;
        this.dialogSecond = false;
        this.dialogThree = false;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = true;
        this.dialogThreeEdit = false;
      } else {
        this.menuLevel = 2;
        this.dialogFirst = false;
        this.dialogSecond = false;
        this.dialogThree = false;
        this.dialogFirstEdit = false;
        this.dialogSecondEdit = false;
        this.dialogThreeEdit = true;
      }
      this.menuform.name = e.label;
      this.menuform.isEnable = e.isEnable;
      this.menuform.parentId = e.parentId;
      this.menuform.url = e.url;
      this.menuform.PBIUrl = e.pbiUrl;
      this.menuform.icon = e.icon;
      this.menuform.code = e.code;
      this.menuform.description = e.description;
      this.menuform.sortNum = e.sortNum;
      this.menuform.id = e.id;
      this.menuform.englishName= e.englishName;
      this.menuform.chineseName=e.chineseName;

    },
    getDataList() {
      let that = this;
      if (this.judge("Menu_View")) {
        //getAllpermissionMenu
        GetAllMenus().then((res) => {
      
          let data = res.result;
          data = JSON.stringify(data).replace(/name/g, "label");
          that.MenuData = JSON.parse(data);

          that.MenuData.forEach((item) => {
            if (item.children.length === 0) {
              delete item.children;
            } else {
              item.children.forEach((e) => {
                if (e.children.length === 0) {
                  delete e.children;
                }
              });
            }
          });
        });
      }
    },
    getMenuByID(menuID) {
      for (var i = 0; i < this.MenuData.length; i++) {
        if (this.MenuData[i].id == menuID) {
          return this.MenuData[i];
        }
        if (this.MenuData[i].children)
          for (var j = 0; j < this.MenuData[i].children.length; j++) {
            if (this.MenuData[i].children[j].id == menuID) {
              return this.MenuData[i].children[j];
            }
            if (this.MenuData[i].children[j].children)
              for (
                var k = 0;
                k < this.MenuData[i].children[j].children.length;
                k++
              ) {
                if (this.MenuData[i].children[j].children[k].id == menuID) {
                  return this.MenuData[i].children[j].children[k];
                }
              }
          }
      }
    },
    withOutLevel(MenuData, level) {
      //复制
      var newMenuData = JSON.parse(JSON.stringify(MenuData));
      var newData = new Array();
      for (var i = 0; i < newMenuData.length; i++) {
        if (newMenuData[i].children && newMenuData[i].children.length != 0) {
          var myArr = this.withOutLevel(newMenuData[i].children, level);
          if (myArr.length == 0) newMenuData[i].children = null;
          else newMenuData[i].children = myArr;
        }

        if (newMenuData[i].menuLevel < level) newData.push(newMenuData[i]);
      }

      return newData;
    },
    onSubmit(menuform) {
    
      this.$refs[menuform].validate((valid) => {
        if (valid) {
          let that = this;
          let isEnable = this.menuform.isEnable === "0";
          delete this.menuform.isEnable;
          this.menuform.sortNum = parseInt(this.menuform.sortNum);
          if (this.menuLevel === 0) {
            delete this.menuform.parentId;
          }
          let data = {};
          //let data = {menuLevel: this.menuLevel, isEnable, code: this.menuform.name, ...this.menuform}
          if (this.menuLevel === 1) {
            data = {
              menuLevel: this.menuLevel,
              isEnable,
              code: this.menuform.code,
              ...this.menuform,
            };
          } else {
            data = {
              menuLevel: this.menuLevel,
              isEnable,
              code: this.menuform.code,
              name: this.menuform.name,
              // parentId: this.menuform.parentId,
              url: this.menuform.url,
              PBIUrl: this.menuform.PBIUrl,
              icon: this.menuform.icon,
              description: this.menuform.description,
              sortNum: this.menuform.sortNum,
              id: this.menuform.id,
              englishName: this.menuform.englishName,
              chineseName: this.menuform.chineseName,
            };
          }

          if (this.menuform.id) {
            data.parentId = this.menuform.parentId;
            UpdateMenu(data).then((res) => {
              if (res.success) {
                that.getDataList();
                that.$message.success(this.$t('Update'));
                that.dialogFirstEdit = false;
                that.dialogSecondEdit = false;
                that.dialogThreeEdit = false;
                that.menuform = {
                  name: "",
                  isEnable: "",
                  parentId: "",
                  url: "",
                  PBIUrl: "",
                  code: "",
                  icon: "",
                  description: "",
                  sortNum: "",
                  englishName: "",
                  chineseName: ""
                };
                //清除菜单缓存
                delItemFormLocalstorage("menuData");
              }
            });
          } else {
            if (this.menuLevel === 2) {
              data.parentId = this.selectTreeId;
            }

            CreateMenu(data).then(
              (res) => {
                if (res.success) {
                  that.getDataList();
                  that.$message.success(this.$t('Creation'));
                  that.dialogFirst = false;
                  that.dialogSecond = false;
                  that.dialogThree = false;
                  that.menuform = {
                    name: "",
                    isEnable: "",
                    parentId: "",
                    code: "",
                    url: "",
                    icon: "",
                    description: "",
                    sortNum: "",
                    englishName: "",
                    chineseName: "",    
                  };
                  //清除菜单缓存
                delItemFormLocalstorage("menuData");

                }
              },
              (err) => {
              }
            );
          }
        } else {
          return false;
        }
      });
    },
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style>
.el-tree {
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  overflow: hidden;
}

.el-tree-node__content {
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  color: #0056a3;
  display: block;
  padding-right: 10px;
}

.el-tree-node__expand-icon {
  color: #0056a3;
}

.el-tree-node__children .custom-tree-node {
  font-size: 12px;
  color: #333;
}

.el-tree .el-button.is-circle {
  padding: 4px;
}

.iconList {
  width: 30px;
  height: 30px;
  text-align: center;
  border: 1px solid #eeeeee;
}

.iconList i {
  padding: 10px 5px;
}

.iconList:hover {
  border: 1px solid #219aff;
}

.icons {
  display: flex;
  flex-wrap: wrap;
}
</style>
<style>
.fa-li.fa-lg {
  left: 0;
}

.fa-li {
  position: relative;
  top: 0;
}
</style>
